
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalPluggedNoChargeLow as ObiBatteryVerticalPluggedNoChargeLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-plugged-no-charge-low.js';
 
 
 

 
 export const ObiBatteryVerticalPluggedNoChargeLow = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-plugged-no-charge-low',
   elementClass: ObiBatteryVerticalPluggedNoChargeLowElement,
   events: {
     
   }
  });
 
 